module.exports = __webpack_public_path__ + "img/title.fb1775a7.png";